import React, { useState, useEffect, useRef } from "react";
import LottieView from "lottie-react-native";
import {
  StyleSheet,
  View,
  TextInput,
  ScrollView,
  Modal,
  Pressable,
  Linking,
} from "react-native";
import FetchCMSEntity from "@components/CMS/FetchCMSEntity";
import { useDispatch, useSelector } from "react-redux";
import ArrowRightMedium from "@assets/svg/ArrowRightMedium";
import Button from "@components/Button";
import Text from "@components/CustomText";
import useCMSEvents from "@hooks/useCMSEvents";
import {
  answerEarlyJourneyQuestionaire,
  earlyJourneyUpdateShopName,
} from "@services/api";
import color from "@constants/color";
import analytics from "@services/analytics";
import { fontFamily } from "@utils/styles";

import CityMallRedTextLogo from "@assets/svg/Jrny/CitymallRedLogo";
import { EARLY_JOURNEY } from "@constants/analyticsEventsCT";
import CallingIcon from "@assets/svg/Jrny/CallingIcon";
import NewCXIcon from "@assets/svg/Jrny/NewCXIcon";
const CMS_KEY = "EJ_CMS_2";
import { actions as authActions } from "@reducers/authReducer";

const ShowClapModal = () => {
  return (
    <View style={styles.infoContainer}>
      <LottieView
        style={styles.lottieContainer}
        source={require("../../assets/anim/clap-animation-yellow.json")}
        autoPlay={true}
        loop={true}
      />
      <Text style={styles.modalText} newfont variant="title_18">
        Badhayi ho!
      </Text>
      <Text newfont variant="body_text_2">
        Aapki shop open ho gyi hai
      </Text>
    </View>
  );
};

const ShowShopNameModal = ({ shopName = "" }) => {
  return (
    <View style={styles.shopContainer}>
      <View style={styles.logoContainer}>
        <NewCXIcon />
      </View>
      <Text style={styles.shopName} newfont variant="title_18">
        {`${shopName} Ji ki \n`}
        <CityMallRedTextLogo />
        {" Dukaan"}
      </Text>
    </View>
  );
};

const containsSpecialCharsAndDigits = (name) => {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  const hasNumber = /\d+/g;
  return specialChars.test(name) || hasNumber.test(name);
};

const earlyJourneySelector = (state) => state.auth.user?.earlyJourney;

const EnterShopName = ({ navigation }) => {
  const [currentStep, setCurrentStep] = useState("CALL_INFO");
  const [shopName, setShopName] = useState("");
  const [isNameWrong, setIsNameWrong] = useState(false);
  const [visible, setVisible] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [syncUser, setSyncUser] = useState(false);
  const {
    cms_1_info = {},
    enterShopNameScreen = {},
    enterAddressScreen = {},
  } = useSelector(earlyJourneySelector) || {};

  const appSettings = useSelector((s) => s.configReducer.appSettings) || {};
  const { cmsPoweredEntities = {} } = appSettings || {};

  const inputRef = useRef(null);

  const dispatch = useDispatch();
  const trackEvent = useCMSEvents("EJ_ENTER_ADDRESS");

  useEffect(() => {
    if (containsSpecialCharsAndDigits(shopName)) {
      setIsNameWrong(true);
    } else {
      setIsNameWrong(false);
    }
  }, [shopName]);

  useEffect(() => {
    analytics.trackEvent(EARLY_JOURNEY.CMS_1_LANDING);
  }, []);

  useEffect(() => {
    if (currentStep === "CALL_INFO" || currentStep === "STEP_2") {
      setVisible(true);
    }
  }, [currentStep]);

  const onChangeText = (text) => {
    const formattedText = text.replace(/[^\x00-\x7F]/, "");
    setShopName(formattedText);
    return formattedText;
  };

  const onPressShopName = async () => {
    setIsSubmitting(true);
    if (!shopName) return;
    const testSpecialCharRegexp = /^[a-zA-Z\s]+$/;
    const testNumberRegexp = /^[a-zA-Z\s]+$/;
    if (
      !testSpecialCharRegexp.test(shopName) ||
      !testNumberRegexp.test(shopName)
    ) {
      setIsSubmitting(false);
      return;
    }
    try {
      const { data } = await earlyJourneyUpdateShopName({ shopName });
      analytics.trackEvent(EARLY_JOURNEY.SHOP_NAME_SUBMITTED, {
        name_submitted: shopName,
      });
      if (data && data?.success) {
        setCurrentStep("STEP_2");
        analytics.trackEvent(EARLY_JOURNEY.SHOP_NAME_POPUP);
        answerEarlyJourneyQuestionaire({ key: "cms_1_viewed", value: true });
      }
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  const onClose = () => {
    setVisible(false);
  };

  const onPressOpenKeyboard = () => {
    if (inputRef.current.isFocused()) {
      inputRef.current.blur();
      inputRef.current.focus();
    } else {
      inputRef.current.focus();
    }
  };

  let disabled = shopName.trim().length <= 2 || isNameWrong;

  return (
    <Pressable
      onTouchEnd={() => {
        visible && setVisible(false);
      }}
      style={{ flex: 1, overflow: "visible" }}
    >
      <ScrollView
        contentContainerStyle={styles.contentContainer}
        style={styles.container}
        keyboardShouldPersistTaps="handled"
      >
        {cmsPoweredEntities &&
        typeof cmsPoweredEntities === "object" &&
        CMS_KEY in cmsPoweredEntities ? (
          <View style={styles.pageContainer}>
            <FetchCMSEntity
              trackEvent={trackEvent}
              id={cmsPoweredEntities[CMS_KEY]}
              type="PAGE"
            />
          </View>
        ) : null}
        <View style={styles.footer}>
          {currentStep === "CALL_INFO" && (
            <View style={styles.contactCMFooterContainer}>
              {/* <View style={styles.contactContainer}>
                <View>
                  <Text newfont variant="title_18">
                    {cms_1_info?.title}
                  </Text>
                  <View style={{ flexDirection: "row" }}>
                    <Text
                      newfont
                      variant="body_text_2"
                      style={[
                        styles.contactText,
                        {
                          fontFamily: fontFamily.bold,
                        },
                      ]}
                    >
                      {cms_1_info?.phone_number}
                    </Text>
                    <Text
                      newfont
                      variant="body_text_3"
                      style={[
                        styles.contactText,
                        {
                          fontFamily: fontFamily.regular,
                        },
                      ]}
                    >
                      {` ${cms_1_info?.time}`}
                    </Text>
                  </View>
                </View>
                <Pressable
                  onPress={onPressCall}
                  style={{ justifyContent: "center" }}
                >
                  <View style={styles.callIconContainer}>
                    <CallingIcon />
                  </View>
                </Pressable>
              </View> */}
              <View style={styles.ctaContainer}>
                <Button
                  buttonWidth="100%"
                  btnText={cms_1_info?.buttonText}
                  buttonFontType="head1"
                  height={48}
                  borderRadius={10}
                  onPress={() => {
                    setVisible(false);
                    setCurrentStep("STEP_1");
                  }}
                  IconRight={
                    <View style={styles.ctaIcon}>
                      <ArrowRightMedium width={14} height={11} />
                    </View>
                  }
                />
              </View>
            </View>
          )}
          {currentStep === "STEP_1" && (
            <View style={styles.step1Container}>
              <Text newfont variant="body_text_4" style={styles.stepText}>
                <Text
                  newfont
                  variant="body_text_4"
                  style={{ color: "rgba(0, 171, 89, 1)" }}
                >
                  1
                </Text>
                /2 Step
              </Text>
              <Text newfont variant="title_18">
                {`${enterShopNameScreen?.heading} `}
              </Text>
              <Text style={styles.makeIdentity} newfont variant="body_text_3">
                {enterShopNameScreen?.subheading}
              </Text>
              <Pressable
                onPress={onPressOpenKeyboard}
                style={styles.inputContainer}
              >
                <TextInput
                  style={styles.input}
                  onChangeText={onChangeText}
                  ref={inputRef}
                  value={shopName}
                  keyboardType={"name-phone-pad"}
                  multiline={false}
                  autoFocus={true}
                />
                {!shopName && (
                  <Text
                    newfont
                    variant="body_text_4"
                    onPress={onPressOpenKeyboard}
                    style={styles.secondInputFooter}
                  >
                    {enterShopNameScreen?.input_placeholder}
                  </Text>
                )}
                {!disabled ? (
                  <Text
                    newfont
                    variant="body_text_4"
                    style={styles.inputFooter}
                    onPress={onPressOpenKeyboard}
                  >
                    {" ji ki CityMall Dukaan"}
                  </Text>
                ) : null}
              </Pressable>
              {isNameWrong && shopName.length > 2 && (
                <Text
                  newfont
                  variant="caption_2"
                  style={{
                    color: color.plain_red,
                    marginBottom: 10,
                  }}
                >
                  {
                    "Special characters [Like  @ , # , _ , -] ad digits are not valid in shop name field"
                  }
                </Text>
              )}
              <View style={styles.ctaContainer}>
                <Button
                  buttonWidth="100%"
                  btnText={enterShopNameScreen?.buttonText}
                  buttonFontType="head1"
                  height={48}
                  disabled={disabled}
                  borderRadius={10}
                  onPress={onPressShopName}
                  isSubmitting={isSubmitting}
                  IconRight={
                    <View style={styles.ctaIcon}>
                      <ArrowRightMedium width={14} height={11} />
                    </View>
                  }
                />
              </View>
            </View>
          )}
          {currentStep === "STEP_2" && (
            <View style={styles.step1Container}>
              <Text newfont variant="body_text_4" style={styles.stepText}>
                <Text
                  newfont
                  variant="body_text_4"
                  style={{ color: "rgba(0, 171, 89, 1)" }}
                >
                  2
                </Text>
                /2 Step
              </Text>
              <Text
                style={{ color: color.mediumBlack }}
                newfont
                variant="title_18"
              >
                {enterAddressScreen?.heading}
              </Text>
              <Text
                newfont
                variant="body_text_3"
                style={styles.step2contextText}
              >
                {enterAddressScreen?.subheading}
              </Text>
              <View style={styles.ctaContainer}>
                <Button
                  buttonWidth="100%"
                  btnText={enterAddressScreen?.buttonText}
                  buttonFontType="head1"
                  height={48}
                  borderRadius={10}
                  containerStyle={styles.buttonContainer}
                  isSubmitting={syncUser}
                  onPress={() => {
                    setSyncUser(true);
                    dispatch(authActions.updateShowCMSOne());
                    analytics.trackEvent(EARLY_JOURNEY.ADDRESS_FORM_CLICKED, {
                      flow: "signup flow",
                    });
                  }}
                  IconRight={
                    <View style={styles.ctaIcon}>
                      <ArrowRightMedium width={14} height={11} />
                    </View>
                  }
                />
              </View>
            </View>
          )}
        </View>
      </ScrollView>
      <Modal
        transparent
        visible={visible}
        onRequestClose={onClose}
        animationType="none"
        statusBarTranslucent
        navigationBarTranslucent
      >
        <View
          style={[
            styles.modalContainer,
            {
              flex: 1, //currentStep === "CALL_INFO" ? 0.8 : 0.7,
            },
          ]}
        >
          {currentStep === "CALL_INFO" ? (
            <ShowClapModal />
          ) : (
            <ShowShopNameModal shopName={shopName} />
          )}
        </View>
      </Modal>
    </Pressable>
  );
};

export default EnterShopName;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    backgroundColor: "rgba(0,0, 0, .6)",
  },
  pageContainer: {
    backgroundColor: color.white,
    position: "absolute",
    flex: 1,
  },
  footer: {
    backgroundColor: color.white,
    position: "absolute",
    bottom: 0,
    padding: 16,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    width: "100%",
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    zIndex: 1000,
  },
  contactContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  callIconContainer: {
    height: 32,
    width: 32,
    backgroundColor: "rgba(33, 149, 242, 1)",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 32,
  },
  stepText: {
    marginTop: 20,
    fontWeight: "600",
    marginBottom: 12,
    color: color.lightBlack,
  },
  contactText: {
    color: color.lightBlack,
  },
  inputContainer: {
    width: "100%",
    margin: 12,
    borderWidth: 1,
    borderColor: color.blank_grey,
    borderRadius: 6,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
  },
  input: {
    height: 48,
    paddingVertical: 10,
    maxWidth: "58%",
    fontFamily: fontFamily.semiBold,
    fontSize: 14,
    color: color.mediumBlack,
  },
  inputFooter: {
    color: color.lightBlack,
    fontFamily: fontFamily.semiBold,
    fontSize: 14,
  },
  secondInputFooter: {
    color: color.lightBlack,
    fontFamily: fontFamily.semiBold,
    fontSize: 14,
    position: "absolute",
    start: 12,
  },
  ctaContainer: {
    // padding: 0,
    // paddingTop: 0,
    width: "100%",
    zIndex: 100,
    borderRadius: 10,
    alignItems: "center",
  },
  ctaIcon: {
    marginLeft: 10,
    marginTop: 5,
  },
  contactCMFooterContainer: {},
  step1Container: {
    alignItems: "center",
  },
  step2Container: {},
  step2contextText: {
    textAlign: "center",
    marginBottom: 20,
    color: color.lightBlack,
  },
  makeIdentity: {
    color: color.lightBlack,
  },
  modalContainer: {
    flex: 0.8,
    backgroundColor: color.lighterBlack,
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  },
  shopContainer: {
    backgroundColor: "#fff",
    width: "90%",
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 49,
  },
  infoContainer: {
    backgroundColor: color.white,
    width: "90%",
    padding: 15,
    paddingVertical: 40,
    borderRadius: 10,
    alignItems: "center",
    height: 240,
    justifyContent: "flex-end",
  },
  modalText: {
    color: color.plain_green,
  },
  lottieContainer: {
    position: "absolute",
    // elevation: 5,
    bottom: 50,
    zIndex: 50,
    flex: 0.8,
  },
  logoContainer: {
    width: 64,
    height: 64,
    borderRadius: 32,
    marginTop: 48,
    justifyContent: "center",
    alignItems: "center",
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    backgroundColor: color.white,
    alignSelf: "center",
  },
  shopName: {
    marginTop: 16,
    textAlign: "center",
  },
  buttonContainer: {
    alignItems: "center",
    zIndex: 100,
  },
  iconRightStyles: {
    marginTop: 20,
  },
});
